import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import { createRoot } from 'react-dom/client';
import { useTranslation } from 'react-multi-lang';
import { uid } from '../../services/hoc/helpers';
import Modal from '../Modal/Modal';

import './Alerts.css';

interface StaticAlertProps {
  show: boolean;
  type: 'warning' | 'error' | 'success' | 'info';
  children?: any;
}

export const StaticAlert = (props: StaticAlertProps) => {
  const [dasharray, setDasharray] = useState<number>(0);
  const id = uid('alert');

  return (
    <>
      {props.show ? (
        <div className={'alert ' + props.type}>
          <div className="alert-content">{props.children}</div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

interface ConfirmModalProps {
  message: string;
  onConfirm(): any;
  drawer_parent?: boolean;
  onClose: Function;
}

const ConfirmModal = (props: ConfirmModalProps) => {
  const t = useTranslation();

  return (
    <Modal open={true} toggle={() => {}} alwaysVisible={true}>
      <p style={{ margin: '0 0 30px' }}>{props.message}</p>
      <button
        className="button bg-gold color-white"
        style={{ minWidth: 80 }}
        onClick={() => {
          props.onConfirm();
          close();
        }}>
        {t('OK')}
      </button>
      <span className="margin-10" />
      <button className="button" onClick={close}>
        {t('Cancel')}
      </button>
    </Modal>
  );
};

const close = () => {
  const target = document.getElementById('confirm-alert');
  //const root = createRoot(target as HTMLElement)
  if (target) {
    // unmountComponentAtNode(target)
    //root.unmount()
    target.parentNode?.removeChild(target);

  }
};

export const Confirm = (props: ConfirmModalProps) => {

  const t = useTranslation();
  let target = document.getElementById('confirm-alert');
  if (!target) {
    target = document.createElement('div');
    target.id = 'confirm-alert';
    target.style.zIndex='1201';
    target.style.position="relative";

  }
  if (props.drawer_parent) {
    let drawer_parent = document.getElementById('Detail_Drawer');
   
    drawer_parent?.appendChild(target);
  } else {
    document.body.appendChild(target);
  }
  return (
    <>
      {createPortal(
        <Modal open={true} toggle={() =>props.onClose? props.onClose():{}} alwaysVisible={true}
     
        >
          <p style={{ margin: '0 0 30px' }}>{props.message}</p>
          <button
            className="button bg-gold color-white"
            style={{ minWidth: 80 }}
            onClick={() => {
              props.onConfirm();
              
              if (props.onClose) props.onClose();
              close()
            }}>
            {t('OK')}
          </button>
          <span className="margin-10" />
          <button
            className="button"
            onClick={() => {
              if (props.onClose) props.onClose();
              close()
            }}>
            {t('Cancel')}
          </button>
        </Modal>,
        target,
      )}
    </>
  );
  // const root =createRoot(target)
  // root.render(createPortal(
  //     <ConfirmModal {...props} />,
  //     document.body
  // ))
};
